import { Flex, SystemProps, Text, LegacyText, Stack, Box } from "flicket-ui";
import styled from "styled-components";
import { Select, Option } from "~components";
import { SeatsIOSeat } from "~components/reservation/constants";
import { PricingHookResponse, useOrganization } from "~hooks";
import { formatSeatLocation, getCategoryDataFromLabel } from "~lib/helpers";
import PriceWithFee from "../../common/common.PriceWithFee";
import { ListItemDetails } from "./actions.item.ListItemDetails";
import { StylesConfig } from "react-select";

const StyledListItem = styled(Flex)<SystemProps>`
  margin-bottom: ${(p) => p.theme.space[3]}px;

  justify-content: space-between;
  align-items: center;
`;

interface ListItemProps {
  seat: SeatsIOSeat;
  options: Option[];
  handleTicketTypeChange: (id: any, newType: any) => void;
  getPrice: PricingHookResponse["getPrice"];
  showHiddenFees?: boolean;
}

export const ListItem = ({
  seat,
  options,
  handleTicketTypeChange,
  getPrice,
  showHiddenFees = false,
}: ListItemProps) => {
  const { organization } = useOrganization();
  const { zone, section } = getCategoryDataFromLabel(seat?.category?.label);

  const [, originalPrice] = getPrice(seat);

  return (
    <StyledListItem mb={{ _: "5/4", md: 3 }} key={seat?.uuid}>
      <Stack flexDir="column" flex={1} gap={2}>
        <Box>
          <Text variant="header.XS">
            {formatSeatLocation(zone, section, seat?.label)}
          </Text>
          <Text variant="small">
            <PriceWithFee
              price={originalPrice}
              showFees={showHiddenFees}
              isSoldOut={seat.ticketType.isSoldOut}
              fee={seat.ticketType.fee}
              currency={organization.currency}
            />
          </Text>
          <ListItemDetails
            name={seat?.ticketType?.label}
            description={seat?.ticketType?.description}
            restrictions={seat?.ticketType?.restrictions}
            ticketImage={
              seat?.ticketType?.ticketImage ?? seat?.ticketType?.addonImage
            }
            ticketType={seat}
            price={originalPrice}
          />
        </Box>
        <Box width="100%">
          <Select
            defaultValue={options[0]}
            options={options}
            onChange={(value) => {
              handleTicketTypeChange(seat?.customId ?? seat.id, value);
            }}
            value={seat.ticketType?.id}
            selectProps={{
              isSearchable: false,
              styles: {
                control: (provided) => ({
                  ...provided,
                  minHeight: "40px",
                  height: "40px",
                }),
              } as StylesConfig,
            }}
            small
            useSingleValue
          />
        </Box>
      </Stack>
    </StyledListItem>
  );
};
